export default "__VITE_ASSET__CpVovrIA__"